import React, { useEffect, useState, useContext, useCallback } from 'react';
import { Grid, FormLabel, FormHelperText, CircularProgress, Typography, InputLabel } from '@material-ui/core';
import { SecondaryButton, TextBox, SelectBox } from '../../../../Core/FormInput';
import AppContext from '../../../../App/AppContext';
import { getTcardScheduleEventsScreenDropdown, postTcardScheduleEventsAddUpdate } from '../../../../Core/Service/T-card-services';

const UpdateScheduleEventsModal = (props) => {
    const { showToast } = useContext(AppContext);
    const [loading, setLoading] = useState(false);
    const [state, setState] = useState({
        id: props.id,

        workTypeEventList: [],
        tCardWorkTypeEventID: '',
        errors: {}
    });

    const fetchDropdownData = useCallback(async () => {
        const dropDownRes = await getTcardScheduleEventsScreenDropdown();
        if (dropDownRes.success) {
            setState((prev) => ({
                ...prev,
                workTypeEventList: dropDownRes.data?.list?.table || []
            }));
        }
    }, []);

    useEffect(() => {
        fetchDropdownData();
    }, [fetchDropdownData]);

    const handleInput = (e) => {
        const { name, value } = e.target;
        setState((st) => ({
            ...st,
            [name]: value,
            errors: { ...st.errors, [name]: '' }
        }));
    };

    const handleSubmit = async (e) => {
        try {
            const data = {
                id: state.id || null,
                tCardWorkTypeEventID: state.tCardWorkTypeEventID
            };
            let res = await postTcardScheduleEventsAddUpdate(data.id, data.tCardWorkTypeEventID);
            if (res.data.success) {
                showToast(`Updated successfully`);
                props.onClose(true);
            } else {
                console.error(res.message);
            }
        } catch (error) {
            console.error('Error submitting data:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            {loading ? (
                <Grid
                    container
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        minHeight: '200px'
                    }}
                >
                    <CircularProgress />
                    <Typography style={{ fontWeight: 'bold', marginLeft: 10 }}>Loading...</Typography>
                </Grid>
            ) : (
                <Grid container spacing={1}>
                    <Grid item xs={12} md={12}>
                        <FormLabel>Work Type</FormLabel>
                        <SelectBox
                            onChange={handleInput}
                            value={state.tCardWorkTypeEventID}
                            name="tCardWorkTypeEventID"
                            List={state.workTypeEventList || []}
                            style={{ marginTop: 9, textAlign: 'left' }}
                        />
                        {state.errors.tCardWorkTypeEventID && <FormHelperText className="mandatoryfields">{state.errors.tCardWorkTypeEventID}</FormHelperText>}
                    </Grid>

                    <Grid item xs={12} style={{ marginTop: 20, marginBottom: 15 }}>
                        <SecondaryButton fullWidth onClick={handleSubmit}>
                            Submit
                        </SecondaryButton>
                    </Grid>
                </Grid>
            )}
        </div>
    );
};

export default UpdateScheduleEventsModal;
